import { runClientComponent } from '../../_common/client/client-component-runner';
import { ArticleOptionsComponent } from './article-options.component';

runClientComponent({ ArticleOptionsComponent });
